import React, { useState } from 'react';
import { formatDate } from '../../../../../utils/sharedFunctions';
import DeliverablesSection from './../DeliverablesSection/DeliverablesSection.js';
import SkillsSection from './../SkillsSection/SkillsSection.js';
import { TextInputDropdown, TextInput, AddData } from '../../../../../components';
import { MenuItem } from "@mui/material";

const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;
const disabledAddbtn = `${process.env.REACT_APP_CDN_URL}/globalAssets/disabledAddbtn.svg`;
const downArrow = `${process.env.REACT_APP_CDN_URL}/globalAssets/briefview/downArrow.svg`;

const InfoTab = ({
    IsInfoEdit,
    SelectedBrief,
    Leads,
    professionals,
    newDeliverable,
    ExistingDeliverables,
    handleFinanceValuesChange,
    handleFulfilmentChange,
    setNewDeliverable,
    handleAddDeliverable,
    handleDeleteDeliverable,
    handleOfferingChange,
    handleContractTypeChange,
    handleLevelChange,
    handleWorkEnv,
    getAadditionalData,
    linkClickedFunc,
    linkClickedFunc2,
    LinkClicked,
    Message,
}) => {
    const getProjectEndDate = (SelectedBrief) => {
        const projectPlan = SelectedBrief?.projectPlan[0];
        const endDate = projectPlan?.projEndDate || projectPlan?.projectEndDate || '';
        return new Date(endDate);
    };
    function getAddDataID(e) {
        const ID = e.currentTarget.id;
        if (Object.keys(SelectedBrief).includes('projectLinks') && ID === 'prolink') {
            setAddDataID(ID);
            return
        };
        if (!Object.keys(SelectedBrief).includes('project') && ID === 'prolink') {
            // setIsMessage(true);
            // setMessageState({
            //     message: 'Brief is not linked to any project!',
            //     type: 'info',
            //     title: 'Info',
            // })
            let message={
                status:true,
                message:'Brief is not linked to any project!',
                type:'info',
                title:'Info'
            };
            Message(message);
        } else {
            setAddDataID(ID);
        };
    };
    const [AddDataID, setAddDataID] = useState('');

    return IsInfoEdit ? (
        <div className='BriefInfoSection'>
            {/* Edit Mode Content */}
            {/* Left Section */}
            <div className='infoContainerSects'>
                <TextInputDropdown style={{ width: '95%' }} placeholder='Talent Partner' label='Talent Partner' value={SelectedBrief.talentPartner?._id || ''} onChange={handleFulfilmentChange} >
                    {Leads.map((item, index) => (<MenuItem value={item._id}>{item.fullName || ''}</MenuItem>))}
                </TextInputDropdown>

                <div className='briefInfo'>
                    <p className='header'>Professional</p>
                    <span><img src={AddIcon} alt='disabled add button' style={{ cursor: 'pointer' }} onClick={getAddDataID} id='addPro' /></span>
                    {AddDataID === 'addPro' && (
                        <div className='transparentCover'>
                            <AddData
                                style={{ padding: '1%', top: '40%', width: '25%', left: '22%' }}
                                SelectedBrief={SelectedBrief}
                                id='addPro'
                                additionalData={professionals}
                                InputType='menudropdown'
                                getData={getAadditionalData}
                                closeComponent={() => { setAddDataID('') }}
                                MenuItems={professionals.map((item) => `${item.firstName} ${item.lastName}`)}
                            />
                        </div>
                    )}
                </div>

                <div className='textAreacontainer' style={{ height: '73.6%' }}>
                    <p style={{ fontWeight: '700', fontSize: '14px', lineHeight: '24px' }}>Description</p>
                    <textarea
                        id='Description'
                        style={{ color: '#AFAFAF' }}
                        value={SelectedBrief?.briefDescription || ''}
                        onChange={handleFinanceValuesChange}
                    ></textarea>
                </div>
            </div>

            {/* Middle Section */}
            <div className='infoContainerSects'>
                <TextInput
                    style={{ width: '95%' }}
                    placeholder='Start Date'
                    label='Start Date'
                    type='date'
                    id='StartDate'
                    value={SelectedBrief?.projectPlan[0]?.projStartDate ? SelectedBrief.projectPlan[0].projStartDate.split('T')[0] : ''}
                    onChange={handleFinanceValuesChange}
                />
                <TextInput
                    style={{ width: '95%' }}
                    placeholder='End Date'
                    label='End Date'
                    type='date'
                    id='EndDate'
                    value={SelectedBrief?.projectPlan[0]?.projEndDate ? SelectedBrief.projectPlan[0].projEndDate.split('T')[0] : ''}
                    onChange={handleFinanceValuesChange}
                />

                <DeliverablesSection
                    newDeliverable={newDeliverable}
                    setNewDeliverable={setNewDeliverable}
                    handleAddDeliverable={handleAddDeliverable}
                    SelectedBrief={SelectedBrief}
                    ExistingDeliverables={ExistingDeliverables}
                    handleDeleteDeliverable={handleDeleteDeliverable}
                />
            </div>

            {/* Right Section */}
            <div className='infoContainerSects'>
                <TextInput
                    style={{ width: '95%' }}
                    placeholder='Industry Category'
                    label='Industry Category'
                    id='Industry'
                    value={SelectedBrief?.industry || ''}
                    onChange={handleFinanceValuesChange}
                />
                <TextInput
                    style={{ width: '95%' }}
                    placeholder='Location'
                    label='Location'
                    id='Location'
                    value={SelectedBrief?.location}
                    onChange={handleFinanceValuesChange}
                />

                <SkillsSection SelectedBrief={SelectedBrief} AddDataID={AddDataID} Message={(evnt)=>Message(evnt)} getAadditionalData={getAadditionalData} linkClickedFunc={linkClickedFunc} linkClickedFunc2={linkClickedFunc2} LinkClicked={LinkClicked} />
            </div>

            {/* Bottom Section */}
            <div className='offeringfSection' style={{ justifyContent: 'space-around', alignItems: 'center' }}>
                <TextInputDropdown
                    style={{ width: '95%' }}
                    placeholder='Offering'
                    label='Offering'
                    value={Array.isArray(SelectedBrief?.servicesOffered) && SelectedBrief?.servicesOffered.length > 0 ?
                        SelectedBrief?.servicesOffered[0] :
                        typeof SelectedBrief?.servicesOffered === 'string' ? SelectedBrief.servicesOffered : ''}
                    onChange={handleOfferingChange}
                >
                    <MenuItem value='Talent Access: Retainer'>Talent Access: Retainer</MenuItem>
                    <MenuItem value='Talent Access: Once off'>Talent Access: Once off</MenuItem>
                    <MenuItem value='Talent Partner: Plcement'>Talent Partner: Placement</MenuItem>
                    <MenuItem value='Talent Partner: Team Assembly'>Talent Partner: Team Assembly</MenuItem>
                    <MenuItem value='Talent Partner: Voucher'>Talent Partner: Voucher</MenuItem>
                    <MenuItem value='Videography'>Videography</MenuItem>
                    <MenuItem value='RWS : Remote workplace simulation'>RWS : Remote workplace simulation</MenuItem>
                </TextInputDropdown>

                <TextInputDropdown
                    style={{ width: '95%', marginTop: '0.6%' }}
                    placeholder='Contract Type'
                    label='Contract Type'
                    value={SelectedBrief.contractType}
                    onChange={handleContractTypeChange}
                >
                    <MenuItem value='Once-Off'>Once-Off</MenuItem>
                    <MenuItem value='Short-Term Placement'>Short-Term Placement</MenuItem>
                    <MenuItem value='Fixed-Term Placement'>Fixed-Term Placement</MenuItem>
                    <MenuItem value='Permanent Placement'>Permanent Placement</MenuItem>
                    <MenuItem value='Ongoing'>Ongoing</MenuItem>
                </TextInputDropdown>

                <TextInputDropdown
                    style={{ width: '95%', marginTop: '3%' }}
                    placeholder='Experience Level'
                    label='Experience Level'
                    value={SelectedBrief.professionalExperienceLevel || ''}
                    onChange={handleLevelChange}
                >
                    <MenuItem value='Entry Level'>Entry Level</MenuItem>
                    <MenuItem value='Junior'>Junior</MenuItem>
                    <MenuItem value='Junior-Intermediate'>Junior-Intermediate</MenuItem>
                    <MenuItem value='Intermediate'>Intermediate</MenuItem>
                    <MenuItem value='Intermediate-Senior'>Intermediate-Senior</MenuItem>
                    <MenuItem value='Senior'>Senior</MenuItem>
                </TextInputDropdown>

                <TextInputDropdown
                    style={{ width: '95%' }}
                    placeholder='Working Environment'
                    label='Working Environment'
                    value={SelectedBrief.workingEnvironment || ''}
                    onChange={handleWorkEnv}
                >
                    <MenuItem value='Remote'>Remote</MenuItem>
                    <MenuItem value='Onsite'>Onsite</MenuItem>
                    <MenuItem value='Hybrid'>Hybrid</MenuItem>
                </TextInputDropdown>

                <div className='textAreacontainer' style={{ maxHeight: '46%', width: '95%', padding: '0% 1%', justifyContent: 'flex-end', position: 'relative' }}>
                    <p style={{ fontWeight: '700', fontSize: '14px', lineHeight: '24px' }} className='p_with_span_add'>
                        Category of Service<span className='the_span'><img src={AddIcon} alt='add icon' id='catService' onClick={getAddDataID} /></span>
                    </p>
                    {AddDataID === 'catService' && (
                        <AddData
                            SelectedBrief={SelectedBrief}
                            id='catservice'
                            InputType='menudropdown'
                            getData={getAadditionalData}
                            closeComponent={() => { setAddDataID('') }}
                            MenuItems={['Design and Illustration', 'Digital Marketing and Social Media', 'Mobile and Web Development', 'Photography and Videography', 'Writing Services', 'Other Services']}
                        />
                    )}

                    <div className='minidisplaybox' style={{ marginBottom: '1%' }}>
                        <div className='minidisplaybox_inner'>
                            {Array.isArray(SelectedBrief?.serviceCategory) && SelectedBrief.serviceCategory.length > 0 ?
                                SelectedBrief.serviceCategory.map((item, index) => {
                                    if (typeof item === 'string' && item !== '') {
                                        return (
                                            <p key={index} className='mini_p_kids' style={{ fontSize: '12px', color: '#6D4194' }}>{item}</p>
                                        );
                                    }
                                })
                                : typeof SelectedBrief?.serviceCategory === 'string' && SelectedBrief.serviceCategory !== '' ?
                                    <p className='mini_p_kids' style={{ fontSize: '12px', color: '#6D4194' }}>{SelectedBrief.serviceCategory}</p> :
                                    null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <div className='BriefInfoSection'>
            {/* View Mode Content */}
            {/* Similar structure as above but in read-only mode */}
            {/* Left Section */}
            <div className='infoContainerSects'>
                <div className='briefInfo'>
                    <p className='header'>Talent Partner</p>
                    <p className='value'>{SelectedBrief?.talentPartner ? SelectedBrief.talentPartner.fullName : SelectedBrief?.fulfillmentLead ? SelectedBrief.fulfillmentLead.fullName : ''}</p>
                </div>
                <div className='briefInfo' style={{ position: 'relative' }}>
                    <p className='header'>Professional</p>
                    <span><img src={disabledAddbtn} alt='disabled add button' id='addPro' /></span>
                </div>
                <div className='briefDescBox'>
                    <p className='header'>Description</p>
                    <div className='descriptionSection'>
                        <p style={{ color: '#AFAFAF' }}>{SelectedBrief?.briefDescription ? SelectedBrief.briefDescription : SelectedBrief.description}</p>
                    </div>
                </div>
            </div>

            {/* Middle Section */}
            <div className='infoContainerSects'>
                <div className='briefInfo'>
                    <p className='header'>Start Date</p>
                    {Object.keys(SelectedBrief).includes('projectPlan') && (Array.isArray(SelectedBrief?.projectPlan)) ? SelectedBrief?.projectPlan.length > 0 ?
                        <p className='value'>{formatDate(SelectedBrief?.projectPlan[0]?.projStartDate || SelectedBrief?.projectPlan[0]?.startDate)}</p>
                        : null
                        : null
                    }
                </div>
                <div className='briefInfo'>
                    <p className='header'>End Date</p>
                    {Object.keys(SelectedBrief).includes('projectPlan') && (Array.isArray(SelectedBrief?.projectPlan)) ? SelectedBrief?.projectPlan.length > 0 ?
                        <p className='value'>{formatDate(getProjectEndDate(SelectedBrief))}</p>
                        : null
                        : null
                    }
                </div>
                <div className='briefDescBox'>
                    <p className='header'>Deliverables & Responsibilities</p>
                    <div className='descriptionSection'>
                        {Object.keys(SelectedBrief).includes('projectPlan') && (Array.isArray(SelectedBrief?.projectPlan)) ? SelectedBrief?.projectPlan.length > 0 ?
                            <>
                                {Object.keys(SelectedBrief?.projectPlan[0]).includes('deliverables') ? <ul style={{ padding: '0px', margin: '1% 0%' }}>{SelectedBrief?.projectPlan[0]?.deliverables.map((item) => {
                                    return (
                                        <li style={{
                                            color: 'rgb(175, 175, 175)',
                                            background: '#fff',
                                            height: '25px',
                                            borderRadius: '10px',
                                            padding: '2%',
                                            display: 'flex',
                                            margin: '1%',
                                            alignItems: 'center'
                                        }}>{item.nameOfItem}</li>
                                    );
                                }) || ''}
                                </ul> : null}
                            </>
                            : null : null}
                    </div>
                </div>
            </div>

            {/* Right Section */}
            <div className='infoContainerSects'>
                <div className='briefInfo'>
                    <p className='header'>Industry Category</p>
                    <p className='value'>{SelectedBrief?.industry || SelectedBrief.brief?.industry || 'Not Assigned'}</p>
                </div>
                <div className='briefInfo'>
                    <p className='header'>Location</p>
                    <p className='value'>{SelectedBrief?.location || 'Not Assigned'}</p>
                </div>
                <div className='textAreacontainer' style={{ maxHeight: '37%', width: '95%', padding: '0% 1% 1% 1%', position: 'relative' }}>
                    <p style={{ fontWeight: '700', fontSize: '14px', lineHeight: '24px' }} className='p_with_span_add'>Project Links</p>
                    <div className='minidisplaybox'>
                        <div className='minidisplaybox_inner'>
                            {Array.isArray(SelectedBrief?.project?.projectLinks) && SelectedBrief.project.projectLinks.length > 0 ?
                                SelectedBrief.project.projectLinks.map((item, index) => {
                                    if (typeof item === 'object' && item.url !== undefined && item.url !== null && item.url !== '') {
                                        return (
                                            <p
                                                key={index}
                                                onMouseUp={linkClickedFunc2}
                                                onMouseDown={linkClickedFunc}
                                                className='mini_p_kids'
                                                style={{ fontSize: '12px', color: LinkClicked ? '#6D4194' : '' }}
                                            >
                                                {item.url}
                                            </p>
                                        );
                                    } else {
                                        return null;
                                    }
                                })
                                : Array.isArray(SelectedBrief?.projectLinks) && SelectedBrief.projectLinks.length > 0 ?
                                    SelectedBrief.projectLinks.map((item, index) => {
                                        if (typeof item === 'object' && item.url !== undefined && item.url !== null && item.url !== '') {
                                            return (
                                                <p
                                                    key={index}
                                                    onMouseUp={linkClickedFunc2}
                                                    onMouseDown={linkClickedFunc}
                                                    className='mini_p_kids'
                                                    style={{ fontSize: '12px', color: LinkClicked ? '#6D4194' : '' }}
                                                >
                                                    {item.url}
                                                </p>
                                            );
                                        } else {
                                            return null;
                                        }
                                    })
                                    : null
                            }
                        </div>
                    </div>
                </div>
                <div className='textAreacontainer' style={{ maxHeight: '37%', width: '95%', padding: '0% 1% ', position: 'relative' }}>
                    <p style={{ fontWeight: '700', fontSize: '14px', lineHeight: '24px' }} className='p_with_span_add'>Skills Of Professional</p>
                    <div className='minidisplaybox' style={{ overflow: 'hidden' }}>
                        <div className='minidisplaybox_inner'>
                            {Array.isArray(SelectedBrief?.skillsOfProfessional) && SelectedBrief.skillsOfProfessional.length > 0 ?
                                SelectedBrief.skillsOfProfessional.map((item, index) => (
                                    <p key={index} className='mini_p_kids' style={{ fontSize: '12px' }}>{item}</p>
                                )) :
                                ''
                            }
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Section */}
            <div className='offeringfSection'>
                <div className='Section'>
                    <p className='header'>Offering</p>
                    <div className='offeringSec'>
                        <p className='value'>{Array.isArray(SelectedBrief.servicesOffered) && SelectedBrief.servicesOffered.length > 0 ? SelectedBrief.servicesOffered[0] : typeof SelectedBrief.servicesOffered === 'string' ? SelectedBrief.servicesOffered : 'Not Selected'}</p>
                        <img src={downArrow} alt="dropdown" />
                    </div>
                </div>
                <div className='Section'>
                    <p className='header'>Contract Type</p>
                    <div className='offeringSec'>
                        <p className='value'>{SelectedBrief.contractType || 'Not Selected'}</p>
                        <img src={downArrow} alt="dropdown" />
                    </div>
                </div>
                <div className='Section'>
                    <p className='header'>Experience Level</p>
                    <div className='offeringSec'>
                        <p className='value'>{SelectedBrief?.professionalExperienceLevel ? SelectedBrief.professionalExperienceLevel : ''}</p>
                        <img src={downArrow} alt="dropdown" />
                    </div>
                </div>
                <div className='Section'>
                    <p className='header'>Working Environment</p>
                    <div className='offeringSec'>
                        <p className='value'>{SelectedBrief.workingEnvironment || 'Not Selected'}</p>
                        <img src={downArrow} alt="dropdown" />
                    </div>
                </div>
                <div className='textAreacontainer' style={{ maxHeight: '46%', width: '95%', padding: '0% 1%', justifyContent: 'flex-end', position: 'relative', left: '2.5%' }}>
                    <p style={{ fontWeight: '700', fontSize: '14px', lineHeight: '24px' }} className='p_with_span_add'>Category of Service</p>
                    <div className='minidisplaybox' style={{ marginBottom: '0%' }}>
                        <div className='minidisplaybox_inner'>
                            {Array.isArray(SelectedBrief?.serviceCategory) && SelectedBrief.serviceCategory.length > 0 ?
                                SelectedBrief.serviceCategory.map((item, index) => {
                                    if (typeof item === 'string' && item !== '') {
                                        return (
                                            <p key={index} className='mini_p_kids' style={{ fontSize: '12px', color: '#6D4194' }}>{item}</p>
                                        );
                                    }
                                })
                                : typeof SelectedBrief?.serviceCategory === 'string' && SelectedBrief.serviceCategory !== '' ?
                                    <p className='mini_p_kids' style={{ fontSize: '12px', color: '#6D4194' }}>{SelectedBrief.serviceCategory}</p> :
                                    null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InfoTab;